// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2fu4d","col":"styles_col__3XUXm"};